export const environment = {
  env: "prod",
  production: true,
  backendEndpoint: "https://combo-backend.combidesk.com",
  intercomAppId: "vyxefwdz"
};
